import { motion } from 'framer-motion';
import { Loader, Mail } from 'lucide-react';
import { Link } from 'react-router';
import { UseFormReturn } from 'react-hook-form';

import { TextField } from '@/components/form/text-field';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { ResetPasswordRequestFormValues } from '@/services/auth/form-schemas';

interface ResetPasswordFormProps {
  form: UseFormReturn<ResetPasswordRequestFormValues>;
  onSubmit: () => void;
  isPending: boolean;
}

export const ResetPasswordForm = ({
  form,
  onSubmit,
  isPending,
}: ResetPasswordFormProps) => {
  return (
    <motion.div
      key="password-reset-request-form"
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className="space-y-4"
        >
          <TextField<ResetPasswordRequestFormValues>
            form={form}
            name="email"
            label="Email"
            autoComplete="email"
          />
          <Button disabled={isPending} className="w-full" type="submit">
            {isPending ? (
              <Loader className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Mail className="mr-2 h-4 w-4" />
            )}
            Send reset link
          </Button>
          <Button
            type="button"
            className="w-full hover:text-primary/75 hover:no-underline"
            variant="link"
            asChild
          >
            <Link to="/login">Return to sign in</Link>
          </Button>
        </form>
      </Form>
    </motion.div>
  );
};
